import { render, staticRenderFns } from "./OrderCardRenderer.vue?vue&type=template&id=7481e322&scoped=true"
import script from "./OrderCardRenderer.vue?vue&type=script&lang=js"
export * from "./OrderCardRenderer.vue?vue&type=script&lang=js"
import style0 from "./OrderCardRenderer.vue?vue&type=style&index=0&id=7481e322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7481e322",
  null
  
)

export default component.exports